export default function makeAbsoluteUrl(baseUrl: string, relativeUrl: string): string {
    const url = new URL(relativeUrl, baseUrl)

    // if relativeUrl is an absolute URL, return it directly
    if (relativeUrl.startsWith('http')) {
        return relativeUrl;
    }

    return url.toString();
}
